import styled from "styled-components";

export const StyledTooltip = styled.span`
  ${({size}) => size && `font-size: ${size}px`};
  padding-left: 3px;
  opacity: 0.5;
  cursor: help;
`;